// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-blockselect-header {
  text-transform: uppercase;
  font-size: 16px;
  margin-bottom: 2px;
}
.srprs-blockselect-header.disabled {
  color: #d3d3d3;
}

.srprs-blockselect {
  width: 100%;
  color: #222;
}
.srprs-blockselect input {
  display: none;
}
.srprs-blockselect label {
  box-shadow: 0 0 6px 0 rgba(34, 34, 34, 0.15);
  display: grid;
  width: 100%;
  height: 100%;
  position: relative;
  line-height: 1.25em;
  cursor: pointer;
  background-color: #fff;
  font-size: 16px;
  margin: 0;
  padding: 20px;
  text-align: left;
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
}
.srprs-blockselect label.label-badge {
  padding: 0 7px 15px;
}
.srprs-blockselect label.label-badge span.label-content {
  line-height: 44px;
  font-size: 22px;
  text-align: center;
}
.srprs-blockselect label.label-badge span.label-content span {
  margin-bottom: 0;
}
.srprs-blockselect label.label-badge span.label-content.giftcard-cell-thanksgiving {
  margin-bottom: 0;
}
.srprs-blockselect label:before {
  width: 100%;
  height: 100%;
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
}
.srprs-blockselect label .badge {
  border-radius: 20px;
  padding: 6px 12px;
  text-align: center;
  font-weight: bold;
  position: relative;
}
.srprs-blockselect label .badge img {
  position: absolute;
  top: -5px;
  left: -5px;
}
.srprs-blockselect label .badge-thanksgiving {
  padding: 6px 15px 6px 22px;
}
.srprs-blockselect label .badge-grey {
  background-color: #e7e7e7;
}
.srprs-blockselect label .badge-lightgreen {
  background-color: #a0ddd2;
}
.srprs-blockselect label .badge-blue {
  background-color: #c7daf4;
}
.srprs-blockselect label .badge-thanksgiving-blue {
  background-color: #c5eff4;
}
.srprs-blockselect label .badge-pink {
  background-color: #f0c5ce;
}
.srprs-blockselect label .badge-thanksgiving-pink {
  background-color: #fde2da;
}
.srprs-blockselect label .badge-yellow {
  background-color: #f5ea47;
}
.srprs-blockselect label .badge-thanksgiving-yellow {
  background-color: #f7f5b0;
}
.srprs-blockselect label .badge-green {
  background-color: #bade94;
}
.srprs-blockselect label .badge-thanksgiving-green {
  background-color: #a7e8bb;
}
.srprs-blockselect label .badge-violet {
  background-color: #efddf9;
}
.srprs-blockselect label .badge-lightblue {
  background-color: #c1e7f6;
}
.srprs-blockselect label .badge-orange {
  background-color: #fac56d;
}
.srprs-blockselect label .label-content span:first-child:not(.srprs-icon) {
  width: 100%;
  display: inline-block;
  font-weight: 800;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.srprs-blockselect label .label-content small {
  margin-right: 10px;
}
.srprs-blockselect label .srprs-button {
  pointer-events: all;
}
.srprs-blockselect label > .srprs-icon {
  width: 50px;
  height: 50px;
  overflow: hidden;
  position: absolute;
  text-align: right;
  top: 0;
  right: 0;
}
.srprs-blockselect label > .srprs-icon:after {
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  border-width: 0;
  border-style: solid;
  border-color: transparent var(--colorBackground) transparent transparent;
}
.srprs-blockselect label > .srprs-icon > svg {
  width: 15px;
  height: auto;
  color: #fff;
  opacity: 0;
  position: relative;
  display: inline-block;
  z-index: 2;
  margin-top: 10px;
  margin-right: 7px;
}
.srprs-blockselect label > .srprs-icon > svg * {
  fill: currentColor;
}
.srprs-blockselect label .label-icon {
  width: 100%;
  display: block;
  margin: 10px 0 20px;
}
.srprs-blockselect label .label-icon .srprs-icon,
.srprs-blockselect label .label-icon svg {
  width: 40px;
  height: auto;
}
.srprs-blockselect label .footer-top {
  display: grid;
}
.srprs-blockselect label .footer-top > span,
.srprs-blockselect label .footer-top strong {
  align-self: center;
  font-size: 16px;
}
.srprs-blockselect label .footer-top strong {
  font-size: 15px;
  font-weight: bold;
  text-transform: uppercase;
}
.srprs-blockselect label .footer-top .srprs-button,
.srprs-blockselect label .footer-top .srprs-tooltip {
  align-self: center;
  justify-self: flex-end;
  margin-right: 0;
}
.srprs-blockselect label .footer-top .srprs-button.type-secondary,
.srprs-blockselect label .footer-top .srprs-tooltip.type-secondary {
  margin-right: -30px;
  text-transform: uppercase;
}
.srprs-blockselect label .footer-top .srprs-button.type-secondary:hover,
.srprs-blockselect label .footer-top .srprs-tooltip.type-secondary:hover {
  padding-left: 2em;
  padding-right: 2em;
}
.srprs-blockselect label .footer-top .srprs-button.type-secondary + span,
.srprs-blockselect label .footer-top .srprs-tooltip.type-secondary + span {
  line-height: 52px;
}
.srprs-blockselect label .footer-top .srprs-button + strong,
.srprs-blockselect label .footer-top .srprs-tooltip + strong {
  word-break: break-all;
  hyphens: auto;
  max-width: calc(100% - 50px);
}
.srprs-blockselect label:hover:before {
  box-shadow: inset 0 0 0 2px var(--colorBackground);
}
.srprs-blockselect label.giftcard-label-thanksgiving {
  padding: 7px 7px 15px;
}
.srprs-blockselect label.giftcard-label-thanksgiving-yellow:hover:before {
  box-shadow: inset 0 0 0 2px #f7f5b0;
}
.srprs-blockselect label.giftcard-label-thanksgiving-yellow > .srprs-icon:after {
  border-color: transparent #f7f5b0 transparent transparent;
}
.srprs-blockselect label.giftcard-label-thanksgiving-green:hover:before {
  box-shadow: inset 0 0 0 2px #a7e8bb;
}
.srprs-blockselect label.giftcard-label-thanksgiving-green > .srprs-icon:after {
  border-color: transparent #a7e8bb transparent transparent;
}
.srprs-blockselect label.giftcard-label-thanksgiving-pink:hover:before {
  box-shadow: inset 0 0 0 2px #fde2da;
}
.srprs-blockselect label.giftcard-label-thanksgiving-pink > .srprs-icon:after {
  border-color: transparent #fde2da transparent transparent;
}
.srprs-blockselect label.giftcard-label-thanksgiving-blue:hover:before {
  box-shadow: inset 0 0 0 2px #c5eff4;
}
.srprs-blockselect label.giftcard-label-thanksgiving-blue > .srprs-icon:after {
  border-color: transparent #c5eff4 transparent transparent;
}
.srprs-blockselect input:checked + .giftcard-label-thanksgiving-yellow::before {
  box-shadow: inset 0 0 0 2px #f7f5b0;
}
.srprs-blockselect input:checked + .giftcard-label-thanksgiving-green::before {
  box-shadow: inset 0 0 0 2px #a7e8bb;
}
.srprs-blockselect input:checked + .giftcard-label-thanksgiving-pink::before {
  box-shadow: inset 0 0 0 2px #fde2da;
}
.srprs-blockselect input:checked + .giftcard-label-thanksgiving-blue::before {
  box-shadow: inset 0 0 0 2px #c5eff4;
}
.srprs-blockselect input:checked + label {
  cursor: default;
  transform: translateY(0px);
}
.srprs-blockselect input:checked + label:before {
  box-shadow: inset 0 0 0 2px var(--colorBackground);
}
.srprs-blockselect input:checked + label .srprs-icon:after {
  border-width: 0 50px 50px 0;
}
.srprs-blockselect input:checked + label .srprs-icon svg {
  opacity: 1;
}
.srprs-blockselect input:disabled + label {
  cursor: default;
  box-shadow: none;
  color: #d3d3d3;
  background-color: #f4f4f4;
  border-width: 1px;
  border-style: solid;
  border-color: #e7e7e7;
}
.srprs-blockselect input:disabled + label:before {
  box-shadow: none;
}
.srprs-blockselect.type-small label {
  padding: 20px;
}
.srprs-blockselect.type-small label .label-content span:first-child {
  margin-bottom: 0;
}
.srprs-blockselect.type-small .action-list-label {
  padding: 0;
  background: none;
  box-shadow: none;
  height: auto;
}
.srprs-blockselect.type-small .action-list-label li:hover {
  transform: none;
}
.srprs-blockselect.type-extras {
  width: calc(100% + 20px);
  margin-right: -10px;
  margin-left: -10px;
}
.srprs-blockselect.type-extras label {
  border-radius: 0;
}
.srprs-blockselect.type-extras label > * {
  width: 100%;
}
.srprs-blockselect.type-extras label:before {
  display: none;
}
.srprs-blockselect.type-extras label .srprs-icon:after {
  border-width: 0 50px 50px 0;
  border-color: transparent #e7e7e7 transparent transparent;
}
.srprs-blockselect.type-extras label .srprs-icon svg {
  opacity: 1;
}
.srprs-blockselect.type-extras label .label-icon {
  height: 38px;
  margin-top: 0;
  margin-bottom: 10px;
}
.srprs-blockselect.type-extras label .label-icon .srprs-icon svg {
  width: 34px;
}
.srprs-blockselect.type-extras label .label-content {
  height: 110px;
}
.srprs-blockselect.type-extras label .label-content span:first-child {
  font-size: 15px;
  font-weight: 800;
  line-height: 1.1em;
  margin-bottom: 4px;
}
.srprs-blockselect.type-extras label .label-content small {
  display: block;
  font-size: 14px;
  line-height: 16px;
}
.srprs-blockselect.type-extras label .footer-top {
  height: 45px;
  grid-template-columns: repeat(2, 1fr);
}
.srprs-blockselect.type-extras label .footer-top strong {
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 14px;
}
.srprs-blockselect.type-extras label .footer-top .hidden-mobile {
  display: none;
}
.srprs-blockselect.type-extras label .footer-top .srprs-button.cutOff-right {
  background: var(--colorBackground);
  border: var(--colorBackground);
  margin-right: -20px;
  padding-right: 10px;
  padding-left: 20px;
}
.srprs-blockselect.type-extras label .footer-top .srprs-button.type-info {
  margin-top: 5px;
}
.srprs-blockselect.type-extras input:checked[disabled] + label {
  cursor: default;
  background: #fff;
  color: #222;
}
.srprs-blockselect.type-extras input:checked[disabled] + label:hover {
  transform: none;
}
.srprs-blockselect.type-extras input:checked[disabled] + label > .srprs-icon:last-child svg path {
  fill: #fff;
}
.srprs-blockselect.type-extras input:checked[disabled] + label > .srprs-icon:last-child:after {
  border-color: transparent #222 transparent transparent;
}
.srprs-blockselect.type-extras input:checked[disabled] + label .footer-top strong {
  color: #222;
}
.srprs-blockselect.type-extras input:checked + label > .srprs-icon:last-child svg path {
  fill: #fff;
}
.srprs-blockselect.type-extras input:checked + label > .srprs-icon:last-child:after {
  opacity: 1;
  border-color: transparent var(--colorBackground) transparent transparent;
}
.srprs-blockselect.type-extras input:checked + label .footer-top strong {
  color: var(--colorBackground);
}
.srprs-blockselect.type-extras input:checked + label .footer-bottom {
  display: none;
}
.srprs-blockselect.type-extras input:disabled + label {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  cursor: default;
  color: #222;
  background-color: #fff;
  border: none;
}
.srprs-blockselect.type-extras a:hover,
.srprs-blockselect.type-extras label:hover {
  transform: scale(1.02);
}
.srprs-blockselect.type-extras a:hover .srprs-icon:after,
.srprs-blockselect.type-extras label:hover .srprs-icon:after {
  opacity: 0.4;
  border-color: transparent var(--colorBackground) transparent transparent;
}
.srprs-blockselect.type-acco .srprs-col {
  padding: 2px;
  margin-bottom: 10px;
}
.srprs-blockselect.type-acco label {
  width: 208px;
  height: 275px;
}
.srprs-blockselect.type-acco label .label-content {
  margin-bottom: 6px;
}
.srprs-blockselect.type-acco label .label-content span:first-child {
  margin-bottom: 4px;
}
.srprs-blockselect.type-acco label .label-content small {
  display: block;
  margin-right: 0;
}
.srprs-blockselect.type-acco label .label-illustration {
  width: 100%;
  height: 120px;
  display: block;
}
.srprs-blockselect.type-acco label .label-illustration .srprs-icon,
.srprs-blockselect.type-acco label .label-illustration svg {
  width: 100%;
  height: auto;
}
.srprs-blockselect.type-acco label .footer-top {
  grid-template-columns: auto 40px;
}
.srprs-blockselect.type-acco label .footer-top .rating > .srprs-icon {
  width: auto;
  height: 14px;
  bottom: -1px;
}
.srprs-blockselect.type-acco label .footer-top .rating > .srprs-icon svg {
  width: auto;
  height: 100%;
}
.srprs-blockselect.type-acco label .footer-top .rating > .srprs-icon svg * {
  fill: currentColor;
}
.srprs-blockselect.type-row label {
  line-height: 20px;
  user-select: none;
  border-radius: 0px;
  font-weight: bold;
  font-size: 15px;
  padding-top: 20px;
  padding-right: 10px;
  padding-bottom: 20px;
  padding-left: 10px;
  text-align: center;
}
.srprs-blockselect.type-row label:before {
  border-radius: 0px;
}
.srprs-blockselect.type-row label:hover {
  transform: none;
}
.srprs-blockselect.type-row label:hover:before {
  box-shadow: inset 0 0 0 2px var(--colorBackground);
}
.srprs-blockselect.type-row label .label-content span:first-child {
  margin-bottom: 0;
  font-weight: 700;
  font-family: font-body;
}
.srprs-blockselect.type-row label > .srprs-icon {
  display: none;
}
.srprs-blockselect.type-row input:checked + label:hover:before {
  box-shadow: inset 0 0 0 3px var(--colorBackground);
}
.srprs-blockselect.type-row input:disabled + label {
  cursor: default;
  border: 0;
}
.srprs-blockselect.type-row input:disabled + label:before {
  box-shadow: inset 0 0 0 1px #e7e7e7;
}
.srprs-blockselect.type-row.is-animated {
  height: 60px;
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(1) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 1));
  animation-name: slidein-1;
  animation-timing-function: ease-out;
}
@keyframes slidein-1 {
  from {
    margin-top: calc(10% + (1 * 5%));
    opacity: calc(0 - (1 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(2) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 2));
  animation-name: slidein-2;
  animation-timing-function: ease-out;
}
@keyframes slidein-2 {
  from {
    margin-top: calc(10% + (2 * 5%));
    opacity: calc(0 - (2 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(3) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 3));
  animation-name: slidein-3;
  animation-timing-function: ease-out;
}
@keyframes slidein-3 {
  from {
    margin-top: calc(10% + (3 * 5%));
    opacity: calc(0 - (3 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(4) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 4));
  animation-name: slidein-4;
  animation-timing-function: ease-out;
}
@keyframes slidein-4 {
  from {
    margin-top: calc(10% + (4 * 5%));
    opacity: calc(0 - (4 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(5) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 5));
  animation-name: slidein-5;
  animation-timing-function: ease-out;
}
@keyframes slidein-5 {
  from {
    margin-top: calc(10% + (5 * 5%));
    opacity: calc(0 - (5 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(6) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 6));
  animation-name: slidein-6;
  animation-timing-function: ease-out;
}
@keyframes slidein-6 {
  from {
    margin-top: calc(10% + (6 * 5%));
    opacity: calc(0 - (6 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(7) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 7));
  animation-name: slidein-7;
  animation-timing-function: ease-out;
}
@keyframes slidein-7 {
  from {
    margin-top: calc(10% + (7 * 5%));
    opacity: calc(0 - (7 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(8) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 8));
  animation-name: slidein-8;
  animation-timing-function: ease-out;
}
@keyframes slidein-8 {
  from {
    margin-top: calc(10% + (8 * 5%));
    opacity: calc(0 - (8 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(9) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 9));
  animation-name: slidein-9;
  animation-timing-function: ease-out;
}
@keyframes slidein-9 {
  from {
    margin-top: calc(10% + (9 * 5%));
    opacity: calc(0 - (9 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-row.is-animated .srprs-col:nth-child(10) label {
  height: 60px;
  animation-duration: calc(400ms + (200ms * 10));
  animation-name: slidein-10;
  animation-timing-function: ease-out;
}
@keyframes slidein-10 {
  from {
    margin-top: calc(10% + (10 * 5%));
    opacity: calc(0 - (10 / 10));
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
.srprs-blockselect.type-region .srprs-col:first-child {
  grid-column: span 2;
  margin-bottom: 15px;
}
.srprs-blockselect.type-region label {
  position: relative;
  line-height: 20px;
  user-select: none;
  border-radius: 0px;
  font-weight: bold;
  font-size: 15px;
  padding-top: 16px;
  padding-right: 10px;
  padding-bottom: 16px;
  padding-left: 36px;
  text-transform: uppercase;
}
.srprs-blockselect.type-region label .label-content span:first-child {
  margin-bottom: 0;
  font-weight: 700;
  font-family: font-body;
}
.srprs-blockselect.type-region label .srprs-icon {
  width: 15px;
  height: 15px;
  position: absolute;
  z-index: 1;
  top: 20px;
  left: 16px;
  overflow: initial;
  margin: 0;
}
.srprs-blockselect.type-region label .srprs-icon svg {
  width: 100%;
  height: auto;
  opacity: 0;
  position: relative;
  z-index: 2;
  transform: scale(0);
}
.srprs-blockselect.type-region label .srprs-icon svg * {
  fill: currentColor;
}
.srprs-blockselect.type-region label .srprs-icon:before {
  width: 20px;
  height: 20px;
  display: inline-block;
  position: absolute;
  content: "";
  z-index: 3;
  top: -5px;
  left: -5px;
  pointer-events: none;
  border-width: 1px;
  border-color: #e7e7e7;
  border-style: solid;
  border-radius: 50%;
}
.srprs-blockselect.type-region label .srprs-icon svg, .srprs-blockselect.type-region label .srprs-icon:after {
  display: none;
}
.srprs-blockselect.type-region label:before, .srprs-blockselect.type-region label:after {
  display: inline-block;
  position: absolute;
  content: "";
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  opacity: 0;
  margin-top: 15px;
  margin-left: 11px;
  border-width: 4px;
  border-style: solid;
  border-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 0px 0px 1px #d3d3d3;
}
.srprs-blockselect.type-region label:before {
  background-color: var(--colorBackground);
}
.srprs-blockselect.type-region label:after {
  transform: none;
  transition: all 300ms ease-in-out;
  background-color: transparent;
  border-color: var(--colorBackground);
}
.srprs-blockselect.type-region label:hover:before {
  opacity: 0.3;
}
.srprs-blockselect.type-region input:checked + label:before {
  opacity: 1;
}
.srprs-blockselect.type-region input:checked + label:after {
  animation: grow-checkbox 600ms normal;
}
.srprs-blockselect.type-button label {
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  height: 40px;
  line-height: 40px;
  padding-left: 22px;
  padding-top: 0;
  padding-right: 22px;
  padding-bottom: 0;
  border-radius: 26px;
  border-color: var(--colorForeground);
  white-space: nowrap;
  text-align: center;
}
.srprs-blockselect.type-button label::before {
  display: none;
}
.srprs-blockselect.type-button label .srprs-icon {
  display: none;
}
.srprs-blockselect.type-button input:checked + label {
  background-color: var(--colorBackground);
}
.srprs-blockselect.type-card input:not(:checked) + label {
  opacity: 0.6;
}
.srprs-blockselect.type-card label {
  padding: 50px;
  padding-bottom: 140px;
}
.srprs-blockselect.type-card label .label-content {
  min-height: 200px;
}
.srprs-blockselect.type-card label .label-content span {
  font-size: 22px;
  line-height: 22px;
}
.srprs-blockselect.type-card label .label-content small {
  display: block;
}
.srprs-blockselect.type-card label .label-illustration figure {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 110px;
}
.srprs-blockselect.type-card label .footer-top {
  grid-template-columns: auto 40px;
}
.srprs-blockselect.type-card label .footer-top strong {
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
@keyframes grow-checkbox {
  0% {
    transform: scale(0);
    opacity: 0.6;
  }
  100% {
    transform: scale(2);
    filter: blur(1px);
    border-radius: 10px;
    opacity: 0;
  }
}

@media screen and (min-width: 375px) {
  .srprs-blockselect.type-extras label .label-content {
    height: 130px;
  }
  .srprs-blockselect.type-extras label .label-icon {
    margin-bottom: 0;
    height: 44px;
  }
  .srprs-blockselect.type-extras label .footer-top .hidden-mobile {
    display: initial;
  }
  .srprs-blockselect.type-card label {
    padding-bottom: 190px;
  }
  .srprs-blockselect.type-card label .label-illustration figure {
    height: 160px;
  }
}
@media screen and (min-width: 640px) {
  .srprs-blockselect label {
    padding: 30px;
  }
  .srprs-blockselect label .footer-top strong {
    font-size: 18px;
  }
  .srprs-blockselect.type-extras label .footer-top .srprs-button.cutOff-right {
    margin-right: -30px;
  }
  .srprs-blockselect.type-acco label {
    font-size: 16px;
  }
  .srprs-blockselect.type-card label {
    padding-bottom: 230px;
  }
  .srprs-blockselect.type-card label .label-illustration figure {
    height: 200px;
  }
}
@media screen and (min-width: 768px) {
  .srprs-blockselect.type-extras label .label-icon {
    height: 52px;
  }
  .srprs-blockselect.type-extras label .label-icon .srprs-icon svg {
    width: 40px;
  }
  .srprs-blockselect.type-extras label .label-content {
    height: 140px;
  }
  .srprs-blockselect.type-extras label .label-content span:first-child {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .srprs-blockselect.type-extras label .label-content small {
    font-size: 17px;
    line-height: 19px;
  }
  .srprs-blockselect.type-extras label .footer-top strong {
    font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    font-size: 18px;
  }
  .srprs-blockselect.type-card label .label-content span {
    font-size: 34px;
    line-height: 34px;
  }
  .srprs-blockselect.type-region .srprs-col:first-child {
    margin-right: 15px;
    margin-bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/BlockSelect/BlockSelect.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AAuMF;AAtME;EACE,cAAA;AAwMJ;;AApMA;EACE,WAAA;EACA,WAAA;AAuMF;AAtME;EACE,aAAA;AAwMJ;AAtME;EIXE,4CAAA;EJaA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EAEE,sBAAA;EAGA,eAAA;EAEF,SAAA;EACA,aAAA;EAEE,gBAAA;EAGA,wBAAA;EACA,0BAAA;EACA,oCAAA;AAiMN;AA9LI;EACE,mBAAA;AAgMN;AA/LM;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AAiMR;AAhMQ;EACE,gBAAA;AAkMV;AAhMQ;EACE,gBAAA;AAkMV;AA9LI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EAEE,wBAAA;EACA,0BAAA;EACA,oCAAA;AA+LR;AA5LI;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA8LN;AA5LM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AA8LR;AA3LI;EACE,0BAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AA3LI;EACE,yBAAA;AA6LN;AAzLQ;EACE,WAAA;EACA,qBAAA;EAEE,gBAAA;EACA,2IAAA;EAGA,mBAAA;EAGA,yBAAA;AAsLZ;AAlLM;EAEI,kBAAA;AAmLV;AA9KI;EACE,mBAAA;AAgLN;AA7KI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,MAAA;EACA,QAAA;AA+KN;AA9KM;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EAEE,eAAA;EACA,mBAAA;EACA,wEAAA;AA+KV;AA5KM;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EAEE,gBAAA;EACA,iBAAA;AA6KV;AA3KQ;EACE,kBAAA;AA6KV;AAxKI;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AA0KN;AAzKM;;EAEE,WAAA;EACA,YAAA;AA2KR;AAvKI;EACE,aAAA;AAyKN;AAxKM;;EAEE,kBAAA;EAEE,eAAA;AAyKV;AAtKM;EAEI,eAAA;EACA,iBAAA;EAGA,yBAAA;AAqKV;AAjKM;;EAEE,kBAAA;EACA,sBAAA;EAEE,eAAA;AAkKV;AA/JQ;;EACE,mBAAA;EAEE,yBAAA;AAiKZ;AA/JU;;EAEI,iBAAA;EACA,kBAAA;AAiKd;AA9JU;;EACE,iBAAA;AAiKZ;AA9JQ;;EACE,qBAAA;EACA,aAAA;EACA,4BAAA;AAiKV;AA1JM;EAEI,kDAAA;AA2JV;AAtJI;EACE,qBAAA;AAwJN;AArJU;EAEI,mCAAA;AAsJd;AAjJU;EACE,yDAAA;AAmJZ;AA7IU;EAEI,mCAAA;AA8Id;AAzIU;EACE,yDAAA;AA2IZ;AArIU;EAEI,mCAAA;AAsId;AAjIU;EACE,yDAAA;AAmIZ;AA7HU;EAEI,mCAAA;AA8Hd;AAzHU;EACE,yDAAA;AA2HZ;AAlHM;EACE,mCAAA;AAoHR;AAhHM;EACE,mCAAA;AAkHR;AA9GM;EACE,mCAAA;AAgHR;AA5GM;EACE,mCAAA;AA8GR;AAxGE;EACE,eAAA;EACA,0BAAA;AA0GJ;AAzGI;EAEI,kDAAA;AA0GR;AAtGM;EAEI,2BAAA;AAuGV;AApGM;EACE,UAAA;AAsGR;AAhGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAEE,yBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,qBAAA;AA+FN;AA7FI;EACE,gBAAA;AA+FN;AAzFI;EACE,aAAA;AA2FN;AAzFQ;EACE,gBAAA;AA2FV;AAtFI;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAwFN;AAtFM;EACE,eAAA;AAwFR;AAlFE;EACE,wBAAA;EAEE,mBAAA;EACA,kBAAA;AAmFN;AAjFI;EAEI,gBAAA;AAkFR;AAhFM;EACE,WAAA;AAkFR;AAhFM;EACE,aAAA;AAkFR;AA/EQ;EAEI,2BAAA;EACA,yDAAA;AAgFZ;AA7EQ;EACE,UAAA;AA+EV;AA5EM;EACE,YAAA;EAEE,aAAA;EACA,mBAAA;AA6EV;AA3EQ;EACE,WAAA;AA6EV;AA1EM;EACE,aAAA;AA4ER;AA3EQ;EAEI,eAAA;EACA,gBAAA;EAGA,kBAAA;EAGA,kBAAA;AAwEZ;AArEQ;EACE,cAAA;EAEE,eAAA;EAEF,iBAAA;AAqEV;AAlEM;EACE,YAAA;EACA,qCAAA;AAoER;AAnEQ;EAEI,2IAAA;EACA,eAAA;AAoEZ;AAjEQ;EACE,aAAA;AAmEV;AAhEU;EACE,kCAAA;EACA,8BAAA;EAEE,mBAAA;EAGA,mBAAA;EACA,kBAAA;AA+Dd;AA5DU;EAEI,eAAA;AA6Dd;AAjDQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAmDV;AAlDU;EACE,eAAA;AAoDZ;AAhDc;EACE,UAAA;AAkDhB;AAhDc;EAEI,sDAAA;AAiDlB;AA3CY;EACE,WAAA;AA6Cd;AAjCY;EACE,UAAA;AAmCd;AAjCY;EACE,UAAA;EAEE,wEAAA;AAkChB;AA3BU;EACE,6BAAA;AA6BZ;AA1BQ;EACE,aAAA;AA4BV;AAtBI;EIziBA,6CAAA;EJ2iBE,eAAA;EACA,WAAA;EAEE,sBAAA;EAEF,YAAA;AAsBN;AAnBI;;EAEE,sBAAA;AAqBN;AApBM;;EACE,YAAA;EAEE,wEAAA;AAsBV;AAdI;EACE,YAAA;EACA,mBAAA;AAgBN;AAdI;EACE,YAAA;EACA,aAAA;AAgBN;AAfM;EACE,kBAAA;AAiBR;AAhBQ;EACE,kBAAA;AAkBV;AAhBQ;EACE,cAAA;EACA,eAAA;AAkBV;AAfM;EACE,WAAA;EACA,aAAA;EACA,cAAA;AAiBR;AAhBQ;;EAEE,WAAA;EACA,YAAA;AAkBV;AAfM;EACE,gCAAA;AAiBR;AAfU;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAiBZ;AAhBY;EACE,WAAA;EACA,YAAA;AAkBd;AAhBY;EACE,kBAAA;AAkBd;AARI;EACE,iBAAA;EACA,iBAAA;EAEE,kBAAA;EAGA,iBAAA;EACA,eAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAGA,kBAAA;AAGR;AADM;EAEI,kBAAA;AAEV;AACM;EACE,eAAA;AACR;AAAQ;EAEI,kDAAA;AACZ;AAIQ;EACE,gBAAA;EAEE,gBAAA;EACA,sBAAA;AAHZ;AAOM;EACE,aAAA;AALR;AAUQ;EAEI,kDAAA;AATZ;AAcI;EACE,eAAA;EACA,SAAA;AAZN;AAaM;EAEI,mCAAA;AAZV;AAgBI;EACE,YAAA;AAdN;AAkBY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AAjBhB;AAsBU;EACE;IACE,gCAAA;IACA,2BAAA;EApBZ;EAuBU;IACE,aAAA;IACA,UAAA;EArBZ;AACF;AAEY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AADhB;AAMU;EACE;IACE,gCAAA;IACA,2BAAA;EAJZ;EAOU;IACE,aAAA;IACA,UAAA;EALZ;AACF;AAdY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AAehB;AAVU;EACE;IACE,gCAAA;IACA,2BAAA;EAYZ;EATU;IACE,aAAA;IACA,UAAA;EAWZ;AACF;AA9BY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AA+BhB;AA1BU;EACE;IACE,gCAAA;IACA,2BAAA;EA4BZ;EAzBU;IACE,aAAA;IACA,UAAA;EA2BZ;AACF;AA9CY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AA+ChB;AA1CU;EACE;IACE,gCAAA;IACA,2BAAA;EA4CZ;EAzCU;IACE,aAAA;IACA,UAAA;EA2CZ;AACF;AA9DY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AA+DhB;AA1DU;EACE;IACE,gCAAA;IACA,2BAAA;EA4DZ;EAzDU;IACE,aAAA;IACA,UAAA;EA2DZ;AACF;AA9EY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AA+EhB;AA1EU;EACE;IACE,gCAAA;IACA,2BAAA;EA4EZ;EAzEU;IACE,aAAA;IACA,UAAA;EA2EZ;AACF;AA9FY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AA+FhB;AA1FU;EACE;IACE,gCAAA;IACA,2BAAA;EA4FZ;EAzFU;IACE,aAAA;IACA,UAAA;EA2FZ;AACF;AA9GY;EACE,YAAA;EAEE,6CAAA;EACA,yBAAA;EACA,mCAAA;AA+GhB;AA1GU;EACE;IACE,gCAAA;IACA,2BAAA;EA4GZ;EAzGU;IACE,aAAA;IACA,UAAA;EA2GZ;AACF;AA9HY;EACE,YAAA;EAEE,8CAAA;EACA,0BAAA;EACA,mCAAA;AA+HhB;AA1HU;EACE;IACE,iCAAA;IACA,4BAAA;EA4HZ;EAzHU;IACE,aAAA;IACA,UAAA;EA2HZ;AACF;AAjHM;EACE,mBAAA;EACA,mBAAA;AAmHR;AAhHI;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EAEE,kBAAA;EAGA,iBAAA;EACA,eAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAGA,yBAAA;AA2GR;AAxGQ;EACE,gBAAA;EAEE,gBAAA;EACA,sBAAA;AAyGZ;AArGM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;AAuGR;AAtGQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AAwGV;AAvGU;EACE,kBAAA;AAyGZ;AAtGQ;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EAEE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AAuGZ;AApGQ;EAEE,aAAA;AAqGV;AAlGM;EAEE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EAGE,gBAAA;EACA,iBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EAEF,mCAAA;AA8FR;AA5FM;EAEI,wCAAA;AA6FV;AA1FM;EACE,eAAA;EACA,iCAAA;EAEE,6BAAA;EAGA,oCAAA;AAyFV;AArFQ;EACE,YAAA;AAuFV;AAlFM;EACE,UAAA;AAoFR;AAlFM;EACE,qCAAA;AAoFR;AA7EI;EACE,0CAAA;EACA,YAAA;EACA,iBAAA;EAEE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EAGA,mBAAA;EACA,oCAAA;EAEF,mBAAA;EACA,kBAAA;AA2EN;AAzEM;EACE,aAAA;AA2ER;AAxEM;EACE,aAAA;AA0ER;AAtEI;EAEI,wCAAA;AAuER;AAhEI;EACE,YAAA;AAkEN;AAhEI;EACE,aAAA;EACA,qBAAA;AAkEN;AAjEM;EACE,iBAAA;AAmER;AAlEQ;EACE,eAAA;EACA,iBAAA;AAoEV;AAlEQ;EACE,cAAA;AAoEV;AAjEM;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AAmER;AAjEM;EACE,gCAAA;AAmER;AAlEQ;EACE,2IAAA;AAoEV;AA9DE;EACE;IACE,mBAAA;IACA,YAAA;EAgEJ;EA9DE;IACE,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,UAAA;EAgEJ;AACF;;AC5+BI;EDo7BI;IACE,aAAA;EA4DR;EA1DM;IACE,gBAAA;IACA,YAAA;EA4DR;EA1DM;IACE,gBAAA;EA4DR;EAtDI;IACE,qBAAA;EAwDN;EAvDM;IACE,aAAA;EAyDR;AACF;AC//BI;ED88BA;IACE,aAAA;EAoDJ;EAnDI;IACE,eAAA;EAqDN;EA9CU;IAEI,mBAAA;EA+Cd;EAvCI;IAEI,eAAA;EAwCR;EAnCI;IACE,qBAAA;EAqCN;EApCM;IACE,aAAA;EAsCR;AACF;ACnhCI;EDw/BI;IACE,YAAA;EA8BR;EA7BQ;IACE,WAAA;EA+BV;EA5BM;IACE,aAAA;EA8BR;EA7BQ;IAEI,eAAA;IAGA,mBAAA;EA4BZ;EAzBQ;IAEI,eAAA;IAEF,iBAAA;EAyBV;EArBQ;IAEI,2IAAA;IACA,eAAA;EAsBZ;EAXQ;IACE,eAAA;IACA,iBAAA;EAaV;EAJM;IAEI,kBAAA;IACA,gBAAA;EAKV;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-blockselect-header {\n  text-transform: uppercase;\n  font-size: 16px;\n  margin-bottom: 2px;\n  &.disabled {\n    color: color(grey);\n  }\n}\n\n.srprs-blockselect {\n  width: 100%;\n  color: color(black);\n  input {\n    display: none;\n  }\n  label {\n    @include box-shadow(blur-s);\n    display: grid;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    line-height: 1.25em;\n    cursor: pointer;\n    background: {\n      color: color(white);\n    }\n    font: {\n      size: 16px;\n    }\n    margin: 0;\n    padding: 20px;\n    text: {\n      align: left;\n    }\n    transition: {\n      property: all;\n      duration: 0.25s;\n      timing-function: ease-out;\n    }\n\n    &.label-badge {\n      padding: 0 7px 15px;\n      span.label-content {\n        line-height: 44px;\n        font-size: 22px;\n        text-align: center;\n        span {\n          margin-bottom: 0;\n        }\n        &.giftcard-cell-thanksgiving {\n          margin-bottom: 0;\n        }\n      }\n    }\n    &:before {\n      width: 100%;\n      height: 100%;\n      content: '';\n      display: inline-block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      pointer-events: none;\n      transition: {\n        property: all;\n        duration: 0.25s;\n        timing-function: ease-out;\n      }\n    }\n    .badge {\n      border-radius: 20px;\n      padding: 6px 12px;\n      text-align: center;\n      font-weight: bold;\n      position: relative;\n\n      img {\n        position: absolute;\n        top: -5px;\n        left: -5px;\n      }\n    }\n    .badge-thanksgiving {\n      padding: 6px 15px 6px 22px;\n    }\n    .badge-grey {\n      background-color: #e7e7e7;\n    }\n    .badge-lightgreen {\n      background-color: #a0ddd2;\n    }\n    .badge-blue {\n      background-color: #c7daf4;\n    }\n    .badge-thanksgiving-blue {\n      background-color: #c5eff4;\n    }\n    .badge-pink {\n      background-color: #f0c5ce;\n    }\n    .badge-thanksgiving-pink {\n      background-color: #fde2da;\n    }\n    .badge-yellow {\n      background-color: #f5ea47;\n    }\n    .badge-thanksgiving-yellow {\n      background-color: #f7f5b0;\n    }\n    .badge-green {\n      background-color: #bade94;\n    }\n    .badge-thanksgiving-green {\n      background-color: #a7e8bb;\n    }\n    .badge-violet {\n      background-color: #efddf9;\n    }\n    .badge-lightblue {\n      background-color: #c1e7f6;\n    }\n    .badge-orange {\n      background-color: #fac56d;\n    }\n    .label-content {\n      span:first-child {\n        &:not(.srprs-icon) {\n          width: 100%;\n          display: inline-block;\n          font: {\n            weight: 800;\n            family: font(heading);\n          }\n          margin: {\n            bottom: 10px;\n          }\n          text: {\n            transform: uppercase;\n          }\n        }\n      }\n      small {\n        margin: {\n          right: 10px;\n        }\n      }\n    }\n\n    .srprs-button {\n      pointer-events: all;\n    }\n\n    > .srprs-icon {\n      width: 50px;\n      height: 50px;\n      overflow: hidden;\n      position: absolute;\n      text-align: right;\n      top: 0;\n      right: 0;\n      &:after {\n        width: 0;\n        height: 0;\n        content: '';\n        position: absolute;\n        z-index: 1;\n        top: 0;\n        right: 0;\n        border: {\n          width: 0;\n          style: solid;\n          color: transparent var(--colorBackground) transparent transparent;\n        }\n      }\n      > svg {\n        width: 15px;\n        height: auto;\n        color: color(white);\n        opacity: 0;\n        position: relative;\n        display: inline-block;\n        z-index: 2;\n        margin: {\n          top: 10px;\n          right: 7px;\n        }\n        * {\n          fill: currentColor;\n        }\n      }\n    }\n\n    .label-icon {\n      width: 100%;\n      display: block;\n      margin: 10px 0 20px;\n      .srprs-icon,\n      svg {\n        width: 40px;\n        height: auto;\n      }\n    }\n\n    .footer-top {\n      display: grid;\n      > span,\n      strong {\n        align-self: center;\n        font: {\n          size: 16px;\n        }\n      }\n      strong {\n        font: {\n          size: 15px;\n          weight: bold;\n        }\n        text: {\n          transform: uppercase;\n        }\n      }\n\n      .srprs-button,\n      .srprs-tooltip {\n        align-self: center;\n        justify-self: flex-end;\n        margin: {\n          right: 0;\n        }\n\n        &.type-secondary {\n          margin-right: -30px;\n          text: {\n            transform: uppercase;\n          }\n          &:hover {\n            padding: {\n              left: 2em;\n              right: 2em;\n            }\n          }\n          & + span {\n            line-height: 52px;\n          }\n        }\n        & + strong {\n          word-break: break-all;\n          hyphens: auto;\n          max-width: calc(100% - 50px);\n        }\n      }\n    }\n\n    // Hover state\n    &:hover {\n      &:before {\n        box: {\n          shadow: inset 0 0 0 2px var(--colorBackground);\n        }\n      }\n    }\n\n    &.giftcard-label-thanksgiving {\n      padding: 7px 7px 15px;\n      &-yellow {\n        &:hover {\n          &:before {\n            box: {\n              shadow: inset 0 0 0 2px #f7f5b0;\n            }\n          }\n        }\n        > .srprs-icon {\n          &:after {\n            border-color: transparent #f7f5b0 transparent transparent;\n          }\n        }\n      }\n      &-green {\n        &:hover {\n          &:before {\n            box: {\n              shadow: inset 0 0 0 2px #a7e8bb;\n            }\n          }\n        }\n        > .srprs-icon {\n          &:after {\n            border-color: transparent #a7e8bb transparent transparent;\n          }\n        }\n      }\n      &-pink {\n        &:hover {\n          &:before {\n            box: {\n              shadow: inset 0 0 0 2px #fde2da;\n            }\n          }\n        }\n        > .srprs-icon {\n          &:after {\n            border-color: transparent #fde2da transparent transparent;\n          }\n        }\n      }\n      &-blue {\n        &:hover {\n          &:before {\n            box: {\n              shadow: inset 0 0 0 2px #c5eff4;\n            }\n          }\n        }\n        > .srprs-icon {\n          &:after {\n            border-color: transparent #c5eff4 transparent transparent;\n          }\n        }\n      }\n    }\n  }\n\n  input:checked + .giftcard-label-thanksgiving {\n    &-yellow {\n      &::before {\n        box-shadow: inset 0 0 0 2px #f7f5b0;\n      }\n    }\n    &-green {\n      &::before {\n        box-shadow: inset 0 0 0 2px #a7e8bb;\n      }\n    }\n    &-pink {\n      &::before {\n        box-shadow: inset 0 0 0 2px #fde2da;\n      }\n    }\n    &-blue {\n      &::before {\n        box-shadow: inset 0 0 0 2px #c5eff4;\n      }\n    }\n  }\n\n  // Selected state\n  input:checked + label {\n    cursor: default;\n    transform: translateY(0px);\n    &:before {\n      box: {\n        shadow: inset 0 0 0 2px var(--colorBackground);\n      }\n    }\n    .srprs-icon {\n      &:after {\n        border: {\n          width: 0 50px 50px 0;\n        }\n      }\n      svg {\n        opacity: 1;\n      }\n    }\n  }\n\n  // Disabled state\n  input:disabled + label {\n    cursor: default;\n    box-shadow: none;\n    color: color(grey);\n    background: {\n      color: lighten(color(grey-light), 5%);\n    }\n    border: {\n      width: 1px;\n      style: solid;\n      color: color(grey-light);\n    }\n    &:before {\n      box-shadow: none;\n    }\n  }\n\n  // Type small\n  &.type-small {\n    label {\n      padding: 20px;\n      .label-content {\n        span:first-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    .action-list-label {\n      padding: 0;\n      background: none;\n      box-shadow: none;\n      height: auto;\n\n      li:hover {\n        transform: none;\n      }\n    }\n  }\n\n  // Type extras\n  &.type-extras {\n    width: calc(100% + 20px);\n    margin: {\n      right: -10px;\n      left: -10px;\n    }\n    label {\n      border: {\n        radius: 0;\n      }\n      > * {\n        width: 100%;\n      }\n      &:before {\n        display: none;\n      }\n      .srprs-icon {\n        &:after {\n          border: {\n            width: 0 50px 50px 0;\n            color: transparent color(grey-light) transparent transparent;\n          }\n        }\n        svg {\n          opacity: 1;\n        }\n      }\n      .label-icon {\n        height: 38px;\n        margin: {\n          top: 0;\n          bottom: 10px;\n        }\n        .srprs-icon svg {\n          width: 34px;\n        }\n      }\n      .label-content {\n        height: 110px;\n        span:first-child {\n          font: {\n            size: 15px;\n            weight: 800;\n          }\n          line: {\n            height: 1.1em;\n          }\n          margin: {\n            bottom: 4px;\n          }\n        }\n        small {\n          display: block;\n          font: {\n            size: 14px;\n          }\n          line-height: 16px;\n        }\n      }\n      .footer-top {\n        height: 45px;\n        grid-template-columns: repeat(2, 1fr);\n        strong {\n          font: {\n            family: font(heading);\n            size: 14px;\n          }\n        }\n        .hidden-mobile {\n          display: none;\n        }\n        .srprs-button {\n          &.cutOff-right {\n            background: var(--colorBackground);\n            border: var(--colorBackground);\n            margin: {\n              right: -20px;\n            }\n            padding: {\n              right: 10px;\n              left: 20px;\n            }\n          }\n          &.type-info {\n            margin: {\n              top: 5px;\n            }\n          }\n        }\n      }\n      .footer-top {\n      }\n    }\n\n    // State included\n    input:checked {\n      &[disabled] {\n        & + label {\n          cursor: default;\n          background: color(white);\n          color: color(black);\n          &:hover {\n            transform: none;\n          }\n          > .srprs-icon {\n            &:last-child {\n              svg path {\n                fill: color(white);\n              }\n              &:after {\n                border: {\n                  color: transparent color(black) transparent transparent;\n                }\n              }\n            }\n          }\n          .footer-top {\n            strong {\n              color: color(black);\n            }\n          }\n        }\n      }\n    }\n\n    // State checked\n    input:checked {\n      & + label {\n        > .srprs-icon {\n          &:last-child {\n            svg path {\n              fill: color(white);\n            }\n            &:after {\n              opacity: 1;\n              border: {\n                color: transparent var(--colorBackground) transparent\n                  transparent;\n              }\n            }\n          }\n        }\n        .footer-top {\n          strong {\n            color: var(--colorBackground);\n          }\n        }\n        .footer-bottom {\n          display: none;\n        }\n      }\n    }\n\n    // State disabled\n    input:disabled + label {\n      @include box-shadow();\n      cursor: default;\n      color: color(black);\n      background: {\n        color: color(white);\n      }\n      border: none;\n    }\n\n    a:hover,\n    label:hover {\n      transform: scale(1.02);\n      .srprs-icon:after {\n        opacity: 0.4;\n        border: {\n          color: transparent var(--colorBackground) transparent transparent;\n        }\n      }\n    }\n  }\n\n  // Type acco\n  &.type-acco {\n    .srprs-col {\n      padding: 2px;\n      margin-bottom: 10px;\n    }\n    label {\n      width: 208px;\n      height: 275px;\n      .label-content {\n        margin-bottom: 6px;\n        span:first-child {\n          margin-bottom: 4px;\n        }\n        small {\n          display: block;\n          margin-right: 0;\n        }\n      }\n      .label-illustration {\n        width: 100%;\n        height: 120px;\n        display: block;\n        .srprs-icon,\n        svg {\n          width: 100%;\n          height: auto;\n        }\n      }\n      .footer-top {\n        grid-template-columns: auto 40px;\n        .rating {\n          > .srprs-icon {\n            width: auto;\n            height: 14px;\n            bottom: -1px;\n            svg {\n              width: auto;\n              height: 100%;\n            }\n            svg * {\n              fill: currentColor;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Type row\n  &.type-row {\n    label {\n      line-height: 20px;\n      user-select: none;\n      border: {\n        radius: 0px;\n      }\n      font: {\n        weight: bold;\n        size: 15px;\n      }\n      padding: {\n        top: 20px;\n        right: 10px;\n        bottom: 20px;\n        left: 10px;\n      }\n      text: {\n        align: center;\n      }\n      &:before {\n        border: {\n          radius: 0px;\n        }\n      }\n      &:hover {\n        transform: none;\n        &:before {\n          box: {\n            shadow: inset 0 0 0 2px var(--colorBackground);\n          }\n        }\n      }\n      .label-content {\n        span:first-child {\n          margin-bottom: 0;\n          font: {\n            weight: 700;\n            family: font-body;\n          }\n        }\n      }\n      > .srprs-icon {\n        display: none;\n      }\n    }\n    input:checked + label {\n      &:hover {\n        &:before {\n          box: {\n            shadow: inset 0 0 0 3px var(--colorBackground);\n          }\n        }\n      }\n    }\n    input:disabled + label {\n      cursor: default;\n      border: 0;\n      &:before {\n        box: {\n          shadow: inset 0 0 0 1px color(grey-light);\n        }\n      }\n    }\n    &.is-animated {\n      height: 60px;\n      .srprs-col {\n        @for $i from 1 through 10 {\n          &:nth-child(#{$i}) {\n            label {\n              height: 60px;\n              animation: {\n                duration: calc(400ms + (200ms * #{$i}));\n                name: slidein-#{$i};\n                timing-function: ease-out;\n              }\n            }\n          }\n\n          @keyframes slidein-#{$i} {\n            from {\n              margin-top: calc(10% + (#{$i} * 5%));\n              opacity: calc(0 - (#{$i} / 10));\n            }\n\n            to {\n              margin-top: 0;\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Type region\n  &.type-region {\n    .srprs-col {\n      &:first-child {\n        grid-column: span 2;\n        margin-bottom: 15px;\n      }\n    }\n    label {\n      position: relative;\n      line-height: 20px;\n      user-select: none;\n      border: {\n        radius: 0px;\n      }\n      font: {\n        weight: bold;\n        size: 15px;\n      }\n      padding: {\n        top: 16px;\n        right: 10px;\n        bottom: 16px;\n        left: 36px;\n      }\n      text: {\n        transform: uppercase;\n      }\n      .label-content {\n        span:first-child {\n          margin-bottom: 0;\n          font: {\n            weight: 700;\n            family: font-body;\n          }\n        }\n      }\n      .srprs-icon {\n        width: 15px;\n        height: 15px;\n        position: absolute;\n        z-index: 1;\n        top: 20px;\n        left: 16px;\n        overflow: initial;\n        margin: 0;\n        svg {\n          width: 100%;\n          height: auto;\n          opacity: 0;\n          position: relative;\n          z-index: 2;\n          transform: scale(0);\n          * {\n            fill: currentColor;\n          }\n        }\n        &:before {\n          width: 20px;\n          height: 20px;\n          display: inline-block;\n          position: absolute;\n          content: '';\n          z-index: 3;\n          top: -5px;\n          left: -5px;\n          pointer-events: none;\n          border: {\n            width: 1px;\n            color: color(grey-light);\n            style: solid;\n            radius: 50%;\n          }\n        }\n        svg,\n        &:after {\n          display: none;\n        }\n      }\n      &:before,\n      &:after {\n        display: inline-block;\n        position: absolute;\n        content: '';\n        width: 20px;\n        height: 20px;\n        top: 0;\n        left: 0;\n        opacity: 0;\n\n        margin: {\n          top: 15px;\n          left: 11px;\n        }\n        border: {\n          width: 4px;\n          style: solid;\n          color: color(white);\n          radius: 50%;\n        }\n        box-shadow: 0px 0px 0px 1px color(grey);\n      }\n      &:before {\n        background: {\n          color: var(--colorBackground);\n        }\n      }\n      &:after {\n        transform: none;\n        transition: all 300ms ease-in-out;\n        background: {\n          color: transparent;\n        }\n        border: {\n          color: var(--colorBackground);\n        }\n      }\n      &:hover {\n        &:before {\n          opacity: 0.3;\n        }\n      }\n    }\n    input:checked + label {\n      &:before {\n        opacity: 1;\n      }\n      &:after {\n        animation: grow-checkbox 600ms normal;\n      }\n    }\n  }\n\n  // Type button\n  &.type-button {\n    label {\n      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);\n      height: 40px;\n      line-height: 40px;\n      padding: {\n        left: 22px;\n        top: 0;\n        right: 22px;\n        bottom: 0;\n      }\n      border: {\n        radius: 26px;\n        color: var(--colorForeground);\n      }\n      white-space: nowrap;\n      text-align: center;\n\n      &::before {\n        display: none;\n      }\n\n      .srprs-icon {\n        display: none;\n      }\n    }\n\n    input:checked + label {\n      background: {\n        color: var(--colorBackground);\n      }\n    }\n  }\n\n  // Type card\n  &.type-card {\n    input:not(:checked) + label {\n      opacity: 0.6;\n    }\n    label {\n      padding: 50px;\n      padding-bottom: 140px;\n      .label-content {\n        min-height: 200px;\n        span {\n          font-size: 22px;\n          line-height: 22px;\n        }\n        small {\n          display: block;\n        }\n      }\n      .label-illustration figure {\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        height: 110px;\n      }\n      .footer-top {\n        grid-template-columns: auto 40px;\n        strong {\n          font-family: font(heading);\n        }\n      }\n    }\n  }\n\n  @keyframes grow-checkbox {\n    0% {\n      transform: scale(0);\n      opacity: 0.6;\n    }\n    100% {\n      transform: scale(2);\n      filter: blur(1px);\n      border-radius: 10px;\n      opacity: 0;\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-blockselect {\n    &.type-extras {\n      label {\n        .label-content {\n          height: 130px;\n        }\n        .label-icon {\n          margin-bottom: 0;\n          height: 44px;\n        }\n        .footer-top .hidden-mobile {\n          display: initial;\n        }\n      }\n    }\n\n    &.type-card {\n      label {\n        padding-bottom: 190px;\n        .label-illustration figure {\n          height: 160px;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-landscape) {\n  .srprs-blockselect {\n    label {\n      padding: 30px;\n      .footer-top strong {\n        font-size: 18px;\n      }\n    }\n    &.type-extras {\n      label {\n        .footer-top {\n          .srprs-button {\n            &.cutOff-right {\n              margin: {\n                right: -30px;\n              }\n            }\n          }\n        }\n      }\n    }\n    &.type-acco {\n      label {\n        font: {\n          size: 16px;\n        }\n      }\n    }\n    &.type-card {\n      label {\n        padding-bottom: 230px;\n        .label-illustration figure {\n          height: 200px;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-blockselect {\n    // Type extras\n    &.type-extras {\n      label {\n        .label-icon {\n          height: 52px;\n          .srprs-icon svg {\n            width: 40px;\n          }\n        }\n        .label-content {\n          height: 140px;\n          span:first-child {\n            font: {\n              size: 20px;\n            }\n            margin: {\n              bottom: 10px;\n            }\n          }\n          small {\n            font: {\n              size: 17px;\n            }\n            line-height: 19px;\n          }\n        }\n        .footer-top {\n          strong {\n            font: {\n              family: font(heading);\n              size: 18px;\n            }\n          }\n        }\n      }\n    }\n\n    // Type card\n    &.type-card {\n      label {\n        .label-content {\n          span {\n            font-size: 34px;\n            line-height: 34px;\n          }\n        }\n      }\n    }\n\n    // Type region\n    &.type-region {\n      .srprs-col {\n        &:first-child {\n          margin: {\n            right: 15px;\n            bottom: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
